import createApi from "../utils/axiosInstance";

// Login API
export const login = async (credentials) => {
  try {
    const api = createApi(false);
    const response = await api.post("/auth/login", credentials);

    if (response.data) {
      const { user, token } = response.data;
      // const hours = expiresIn?.split("h")[0];
      // const expirationTime = new Date().getTime() + hours * 60 * 60 * 1000;
      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(user));
      // localStorage.setItem("expirationTime", expirationTime);
    }

    return response.data;
  } catch (error) {
    console.error(
      "Login failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};

// Register API
export const register = async (userData) => {
  try {
    const api = createApi(false);
    const { date, ...rest } = userData;
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await api.post(`/auth/signup?date=${date}&tz=${tz}`, rest);
    if (response.data) {
      const { user, token } = response.data;
      // const hours = expiresIn?.split("h")[0];
      // const expirationTime = new Date().getTime() + hours * 60 * 60 * 1000;
      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(user));
      // localStorage.setItem("expirationTime", expirationTime);
    }
    return response.data;
  } catch (error) {
    console.error(
      "Registration failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};

export const verifyIdentity = async (sessionData) => {
  try {
    const api = createApi(false);
    const response = await api.post("/auth/verify-identity", sessionData);
    // if (response.data) {
    //   const { user, token } = response.data;
    //   if (user && token) {

    //     localStorage.setItem("token", token);
    //     localStorage.setItem("user", JSON.stringify(user));
    //     // localStorage.setItem("expirationTime", expirationTime);
    //   }
    return response.data;
  } catch (error) {
    console.error(
      "Verify identity failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};

// Logout API
export const logout = async () => {
  try {
    // Remove token from localStorage on logout
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("lastDiaryVisitedLevel");
    localStorage.removeItem("diaryLastVisited");
    localStorage.removeItem("lastVisitedRoute");
    localStorage.removeItem("foodSearchFilterType");
    localStorage.removeItem("isOverviewVisited");
    localStorage.removeItem("copyIngredientsData");
    localStorage.removeItem("selectedStatFilter");
    // localStorage.removeItem("expirationTime");
    return { message: "Success! You can now login again" };
  } catch (error) {
    console.error(
      "Logout failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};

export const forgetPassword = async (email) => {
  try {
    const api = createApi(false);
    const response = await api.post("/auth/forgotPassword", email);

    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("expirationTime");
    return response.data;
  } catch (error) {
    console.error(
      "Forget password failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};

export const resetPassword = async (userData) => {
  try {
    const api = createApi(false);
    const response = await api.post("/auth/resetPassword", userData);
    return response.data;
  } catch (error) {
    console.log("error", error);
    console.error(
      "Reset Password failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};

export const fetchAllBillingDetails = async () => {
  try {
    const api = createApi(true);
    const response = await api.get("/user/get-manage-billing-details");
    return response.data;
  } catch (error) {
    console.log("error", error);
    console.error(
      "fetch billing failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};

export const fetchAllCards = async () => {
  try {
    const api = createApi(true);
    const response = await api.get("/payment/card/get-card");
    return response.data;
  } catch (error) {
    console.log("error", error);
    console.error(
      "Reset Password failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};

export const createNewCard = async (cardData) => {
  try {
    const api = createApi(true);
    const response = await api.post("/payment/card/add-card", cardData);
    return response.data;
  } catch (error) {
    console.log("error", error);
    console.error(
      "Reset Password failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};

export const updateCard = async (
  // cardData,
  cardId
) => {
  try {
    const api = createApi(true);
    const response = await api.post(
      `/payment/card/edit-card/${cardId}`
      // cardData
    );
    return response.data;
  } catch (error) {
    console.log("error", error);
    console.error(
      "Reset Password failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};

export const removeCard = async (cardId) => {
  try {
    const api = createApi(true);
    const response = await api.post(`/payment/card/remove-card/${cardId}`);
    return response.data;
  } catch (error) {
    console.log("error", error);
    console.error(
      "Reset Password failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};

export const trackCapiEvent = async (eventName, customData = {}, url = window.location.href) => {
  try {
    const api = createApi(false);
    // Explicitly add token if available, though createApi might handle it
    const token = localStorage.getItem("token");
    const headers = {};
    if (token) {
      headers["Authorization"] = token;
    }
    const response = await api.post("/auth/track-event", {
      eventName,
      customData,
      url
    }, { headers });
    return response.data;
  } catch (error) {
    console.error(
      "Track event failed:",
      error.response ? error.response.data : error.message
    );
    // don't throw error to avoid breaking the UI
    return null;
  }
};
